module.exports = __webpack_public_path__ + "img/Fiche chargé d'animation visuelle.68b20a26.jpg";